import { Route, Routes } from "react-router-dom";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import Step4 from "./Step4";
import SignupProvider from "../../../context/SignupContext";

const ResetPassword = () => {
  return (
    <>
      <SignupProvider>
        <Routes>
          <Route path="/" element={<Step1 />} />
          <Route path="emailConfirmation" element={<Step2 />} />
          <Route path="passwordReset" element={<Step3 />} />
          <Route path="resetsuccess" element={<Step4 />} />
        </Routes>
      </SignupProvider>
    </>
  );
};

export default ResetPassword;
